const featuredCollectionCards = document.querySelectorAll('.featured-collection-card');

// Function to update the transform of each translate target
function updateTransforms() {
  featuredCollectionCards.forEach((card) => {
    const content = card.querySelector('.featured-collection-card__desc');
    const translateTarget = card.querySelector('.featured-collection-card__heading-wrap');

    if (content && translateTarget) {
      const contentHeight = content.offsetHeight;
      translateTarget.style.transform = `translateY(${contentHeight}px)`;
    }
  });
}

// Initial transform application
if (featuredCollectionCards) {
  updateTransforms();

  // Add event listener to handle window resize
  window.addEventListener('resize', () => {
    updateTransforms();
  });
}
